import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { EnvService } from '@src/app/modules/env';

import { DownloadLinksComponentOptions } from './types';

@Component({
  selector: 'app-download-links',
  templateUrl: './download-links.component.html',
  styleUrls: ['./download-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadLinksComponent {
  public readonly env = inject(EnvService);

  @Input() options?: DownloadLinksComponentOptions;

  get downloadOptions() {
    return this.options;
  }

  getDownloadLink() {
    if (this.env.isWebIos) {
      return this.downloadOptions?.iosDownloadLink;
    }

    if (this.env.isWebAndroid) {
      return this.downloadOptions?.androidDownloadLink;
    }

    return '';
  }
}
